import { useNavigate } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import LazyBookCover from './LazyBookCover';

const SHELF_LABELS = {
  read: 'Read',
  reading: 'Reading',
  want: 'Want to Read',
  own: 'Own',
  dnf: 'DNF',
};

const SHELF_COLORS = {
  read: 'bg-forest/10 text-forest border-forest/20',
  reading: 'bg-terra/10 text-terra border-terra/20',
  want: 'bg-gold/10 text-ink-light border-gold/20',
  own: 'bg-ink/10 text-ink border-ink/20',
  dnf: 'bg-red-100 text-red-700 border-red-200',
};

export default function BookCard({ book, shelfState, compact = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (book.id) {
      navigate(`/books/${book.id}`);
    } else if (book.google_books_id) {
      navigate(`/books/google/${book.google_books_id}`);
    }
  };

  const coverUrl = book.cover_url || book.thumbnail;

  if (compact) {
    return (
      <button
        onClick={handleClick}
        className="flex items-center gap-3 w-full text-left hover:bg-cream-dark rounded-lg p-2 transition-colors group"
      >
        <div className="w-10 h-14 flex-shrink-0 rounded overflow-hidden bg-cream-dark">
          <LazyBookCover src={coverUrl} alt={book.title} iconClassName="w-4 h-4" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-ink truncate group-hover:text-terra transition-colors font-heading">
            {book.title}
          </p>
          <p className="text-xs text-ink-muted truncate">{book.author || book.authors}</p>
        </div>
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      className="group text-left w-full focus:outline-none"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-cream-dark mb-2 shadow-sm group-hover:shadow-md transition-shadow">
        <LazyBookCover
          src={coverUrl}
          alt={book.title}
          className="group-hover:scale-105 transition-transform duration-300"
          iconClassName="w-8 h-8"
        />
        {shelfState && (
          <div className="absolute bottom-2 left-2">
            <Badge className={`text-xs ${SHELF_COLORS[shelfState]} border`}>
              {SHELF_LABELS[shelfState]}
            </Badge>
          </div>
        )}
      </div>
      <div>
        <p className="text-sm font-semibold text-ink group-hover:text-terra transition-colors line-clamp-2 font-heading leading-tight">
          {book.title}
        </p>
        <p className="text-xs text-ink-muted mt-0.5 truncate">
          {book.author || book.authors}
        </p>
      </div>
    </button>
  );
}
